module.exports = __webpack_public_path__ + "static/media/0010_LES_MURS_PAPIER_BRIQUE_BLANCHE.ae1b5436.png";